import get from 'lodash/get';

import { CLIENT_CACHE_KEY } from '@web/constants';

export default function getFromClientCache(path: string, defaultValue) {
  const clientCache = JSON.parse(localStorage.getItem(CLIENT_CACHE_KEY)) || {};
  return get(clientCache, path, defaultValue);
}
